
export class BasicBatchWrapper {
batchKind: string;
businessUnitCode: string;
cleanOnExit: number | null;
domain: string;
errorCode: string;
login: string;
status: string;
uuid: string;
}

